import * as React from 'react';
import { useState, useRef } from 'react';
import { Button, Grid, TextField, Dialog, DialogContent } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AddClient from './AddClient';
import GetAllClients from './GetAll';
import GetClient from './GetClient';
import { buttonStyle} from "../constants";

const ClientData = () => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  // Create ref to hold reference to GetClient's refresh function
  const clientGridRef = useRef(null);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  // Function to refresh client list from parent
  const refreshClients = () => {
    if (clientGridRef.current && clientGridRef.current.refreshClientList) {
      clientGridRef.current.refreshClientList();
    }
  };

  return (
    <div style={{ marginLeft: "20px", marginRight: "5px" }}>
      <Grid container direction="column">
        <Grid item>
          <Button
            variant="contained"
            onClick={handleOpen}
            sx={{ float: "right", margin: "25px",  ...buttonStyle  }}
          >
            <AddIcon />
            Client
          </Button>
          <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{
              sx: {
                backgroundColor: "transparent",
                boxShadow: "0px 0px 15px 5px rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                width: "400px",
              },
            }}
          >
            <DialogContent
              sx={{
                padding: 0,
                backgroundColor: "transparent",
              }}
            >
              <AddClient 
                handleClose={handleClose} 
                refreshClientList={refreshClients}
              />
            </DialogContent>
          </Dialog>
        </Grid>
        <Grid item sx={{ marginTop: "-5vh" }}>
          <GetClient ref={clientGridRef} />
        </Grid>
      </Grid>
    </div>
  );
};

export default ClientData;